import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import React, { InputHTMLAttributes } from "react";
import { Label } from "reactstrap";


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    /** @param {any} label specifies the title of the text track */
    label: any,
    /** @param {any} data is to show the dropdown list */
    data: Array<any>,
    /** @param {any} placeholder what kind of information is expected in the field*/
    placeholder?: any;
    /** @param {any} name reference of the elements*/
    name: any;
    /** @param {any} id defines the id of the DOM element */
    id: any,
    /** @param {any} value is used to set or get the value for the input field*/
    value: any;
    /** @param {any} onChange is detects when the value of an input element changes.*/
    onChange: any;
    /** @param {any} onBlur is fires the moment that the element loses focus*/
    onBlur?: any;
    /** @param {any} error interferes with the proper operation of the program*/
    error: any;
    /** @param {any} invalid occurs when you're trying to perform on an invalid value.*/
    invalid?: any;
    /** @param {any} touched it takes boolean values as input and it sets to true if a field is clicked*/
    touched: any,
    /** @param {any} valueField is defines the field value*/
    valueField: string,
    /** @param {any} displayField is defines the field display*/
    displayField: string,
    displayField2?: string,
    displayField3?: string,
    /** @param {any} defaultValue is defines the default Value*/
    defaultValue: any,
    /** @param {any} isMandatory is defines the if it's mandatory or not*/
    isMandatory?: boolean,
    filterOptions?: any,
    onKeyDown?: any,
    onTextFieldChange?: any
}

export const CustomAutoComplete = React.forwardRef(({ label, id, displayField2, displayField3, name, placeholder, displayField, valueField, data, error, defaultValue, touched, invalid, isMandatory, onChange, filterOptions, onKeyDown, value, onTextFieldChange, ...rest }: inputProps, ref) => {
    let valueData = data.find(x => x[`${valueField}`] === value);
    return (
        <>
            <Label className="mt-3 mb-1" htmlFor={`${displayField}`}>{label}</Label>
            {isMandatory ? <span style={{ color: 'red' }}>*</span> : null}
            <Autocomplete
                value={valueData == undefined ? null : valueData}
                onKeyDown={onKeyDown}
                noOptionsText={'No Options'}
                freeSolo={true}
                className={(error && touched) ? "error" : ""}
                style={{ border: (error && touched) ? "1px solid #f57777" : "unset", borderRadius: (error && touched) ? "5px" : "" }}
                onChange={onChange}
                options={data}
                defaultValue={valueData}
                clearOnBlur={true}
                size="small"
                filterOptions={filterOptions}
                getOptionLabel={(option: any) => {
                    const displayName = option[`${displayField}`] || "";
                    const displayName3 = (option[`${displayField3}`] && option[`${displayField3}`] != "null") ? ` ${option[`${displayField3}`]}` : "";
                    const displayName2 = (option[`${displayField2}`] && option[`${displayField2}`] != "null") ? ` - ${option[`${displayField2}`]}` : "";
                    return `${displayName}${displayName3}${displayName2}`;
                }}
                renderOption={(props, options) => {
                    const displayName = options[`${displayField}`] || "";
                    const displayName3 = (options[`${displayField3}`] && options[`${displayField3}`] != "null") ? ` ${options[`${displayField3}`]}` : "";
                    const displayName2 = (options[`${displayField2}`] && options[`${displayField2}`] != "null") ? ` - ${options[`${displayField2}`]}` : "";
                    return (
                        <li {...props} key={options[`${valueField}`]}>
                            {displayName}{displayName3}{displayName2}
                        </li>
                    );
                }}
                renderInput={(params) => (
                    <TextField {...params} placeholder={`Select ${label}`}
                        onChange={onTextFieldChange}
                        InputProps={{
                            ...params.InputProps,
                            style: {
                                fontSize: "14px", height: '35px'
                            },
                            endAdornment: (
                                <InputAdornment position="end">
                                    {(error && touched) ?
                                        <i style={{ color: "#f57777", fontSize: "large" }} className="mdi mdi-alert-circle-outline"></i>
                                        :
                                        null
                                    }
                                </InputAdornment>
                            )
                        }} />
                )}
            />
            {(error && touched) && <span className="text-danger fa-xs" >{error as any}</span>}
        </>
    );
});